export enum SessionFlow {
	REGULAR = 'REGULAR',
	INTERNAL_OAUTH = 'INTERNAL_OAUTH',
	EXTERNAL_OAUTH = 'EXTERNAL_OAUTH'
}